import styles from "./ResourcesPopupModal.module.css"
import PopupModal from "./PopUpModal"
import { useState } from "react"

export default function ResourcesPopupModal({image, title, desc, popup}) {
    const [showPopup, setShowPopup] = useState(false);

    return (
            <>
                <div style={{height: "100% !important", position: "relative"}} className='d-flex flex-column gap-2 align-items-start justify-content-start p-2'>
                    <div className={`${styles.popupWrapper}`}>
                        <div className={`${styles.popupLeft}`}>
                            {image && <img src={image} alt={title} className={`${styles.popupImage}`} />}
                        </div>

                        {/* <div className={`${styles.popupRight}`}>
                        <p className={`${styles.popupDesc}`}>{desc}</p>
                        <h2 className={`${styles.popupTitle}`}>{title}</h2>
                        <form className={`${styles.popupForm}`} onSubmit={(e) => e.preventDefault()} noValidate>
                            <input type="email" placeholder="Email ID" className={styles.popupInput} />
                            <button type="submit" className={`${styles.popupBtn}`} >
                                Start Now!
                            </button>
                        </form>
                        </div> */}
                    </div>
                    <div>
                        <div style={{marginTop: "30px", fontSize: "20px !important", color: "black"}} >
                            <h6>{title}</h6>
                        </div>
                        <div>
                            <p style={{fontWeight: 400}}>{desc}</p>
                        </div>
                    </div>
                    <div style={{position: "relative", width: "100%", height: "40px"}}>
                    </div>
                    <button onClick={() => setShowPopup(true)} className={`${styles.testPopupBtn}`}>Read More</button>
                </div>
                {
                    showPopup && <PopupModal show={showPopup} onClose={() => setShowPopup(false)} popup={popup} />
                }
            </>
        )
}